import * as Immutable from 'immutable'
import * as React from 'react'
import { Option } from 'widgets-for-react'
import SimpleFormat from '../../utils/SimpleFormat'

type Selectable = {
  id: number
  name: string
  label: string
  extraSelected: string
}

export type ChooseOptionProps<Selection extends Selectable> = {
  options: Selection[]
  selected: string
  title: string
  intro: string
  submitLabel: string
  error: Option<string>
  selectThis: (s: string) => void
  selectThisExtraFor: (id: number, s: string) => void
  onSubmit: () => void
  formDisabled: boolean
  submitDisabled: boolean
  images: Immutable.Map<string, string>
  extraSelections: Immutable.Map<string, Selectable[]>
  emptyExtraOptionLabel: string
}

const displayExtraOptions = <Selection extends Selectable>(
  method: Selection,
  props: ChooseOptionProps<Selection>
): boolean =>
  method.name === props.selected && !!props.extraSelections.get(method.name)

export function ChooseOptionComponent<Selection extends Selectable>(
  props: ChooseOptionProps<Selection>
): JSX.Element {
  return (
    <div className="grid-container grid-container--medium">
      <div className="grid-100">
        <header className="box">
          <h1>{props.title}</h1>
          <p>{props.intro}</p>
        </header>
        {props.error.v.kind === 'r' ? (
          <div className="box box--bordered box--warning">
            <div className="box__body">
              <SimpleFormat text={props.error.v.v} />
            </div>
          </div>
        ) : (
          <></>
        )}

        <div className="page-section--payment-methods">
          <form
            onSubmit={x => {
              x.preventDefault()
              props.onSubmit()
            }}
            className="grid-container"
          >
            <fieldset className="input optional box box--bordered">
              <div className="box box--brown">
                {props.options.map(method => (
                  <label
                    className={`box__body ${
                      displayExtraOptions(method, props)
                        ? 'extra-options-visible'
                        : ''
                    }`}
                    key={method.id}
                  >
                    <div className="box__inner">
                      <div
                        className={`input boolean ${
                          method.name === props.selected &&
                          !!props.extraSelections.get(method.name)
                            ? 'select'
                            : ''
                        }`}
                      >
                        <input
                          type="radio"
                          value={method.name}
                          disabled={props.formDisabled}
                          checked={props.selected === method.name}
                          onChange={x =>
                            props.selectThis(x.currentTarget.value)
                          }
                        />
                        <span>{method.label}</span>
                      </div>
                      {displayExtraOptions(method, props) ? (
                        <div>
                          <select
                            name={`extra_${method.name}`}
                            disabled={props.formDisabled}
                            value={method.extraSelected}
                            onChange={e =>
                              props.selectThisExtraFor(
                                method.id,
                                e.currentTarget.value
                              )
                            }
                            id="issuers-selector"
                          >
                            <option value="">
                              {props.emptyExtraOptionLabel}
                            </option>
                            {props.extraSelections
                              .get(method.name)
                              .map(extra => (
                                <option key={extra.id} value={extra.name}>
                                  {extra.label}
                                </option>
                              ))}
                          </select>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>

                    {!!props.images.get(method.name) ? (
                      <img
                        className="box__image"
                        src={props.images.get(method.name)}
                        alt={method.name}
                      />
                    ) : (
                      <></>
                    )}
                  </label>
                ))}
              </div>
            </fieldset>
            <input
              type="submit"
              value={props.submitLabel}
              disabled={props.submitDisabled}
              className="btn btn--primary btn--block"
            />
          </form>
        </div>
      </div>
    </div>
  )
}
